import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import axios from 'axios';
import './Event.css';
import { useNavigate, useParams } from 'react-router-dom';
axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URL;

const EventFormModal = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // Get the event ID from the URL
  const [greetings, setGreetings] = useState('');
  const [questions, setQuestions] = useState([{ text: '' }]);
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const [lastMessage, setLastMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch event data when the component mounts
  useEffect(() => {
    if (id) {
      const fetchEvent = async () => {
        setIsLoading(true);
        try {
          const response = await axios.get(`/auth/event/questions/${id}`);
          const event = response.data.event;
          setSelectedLanguage(event.language);
          setGreetings(event.greetings);
          setQuestions(event.questions);
          setLastMessage(event.lastMessage);
        } catch (err) {
          setError('Error fetching event data');
        } finally {
          setIsLoading(false);
        }
      };
      fetchEvent();
    }
  }, [id]);

  const handleQuestionChange = (index, value) => {
    const updatedQuestions = [...questions];
    updatedQuestions[index].text = value;
    setQuestions(updatedQuestions);
  };

  const addQuestion = () => {
    setQuestions([...questions, { text: '' }]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    try {
      const eventData = {
        language: selectedLanguage,
        greetings,
        questions,
        lastMessage,
      };

      if (id) {
        // Update existing event
        await axios.put(`/auth/event/questions/${id}`, eventData);
      } else {
        // Create new event
        await axios.post('/auth/event/questions', eventData);
      }

      // Redirect to the event list page
      navigate('/event');
    } catch (err) {
      setError(err.response?.data?.message || 'Error saving event');
    } finally {
      setIsLoading(false);
    }
  };

  const [languages] = useState([
    'English', 'Spanish', 'French', 'German', 'Japanese', 'Chinese', 'Hindi', 'Arabic',
    'Portuegese', 'Portuguese', 'Russian', 'Bengali', 'Punjabi', 'Korean', 'Italian', 'Dutch', 'Turkish',
    'Vietnamese', 'Polish', 'Ukrainian', 'Persian', 'Greek', 'Hebrew', 'Thai', 'Swedish',
    'Czech', 'Indonesian', 'Romanian', 'Hungarian', 'Danish', 'Finnish', 'Norwegian',
    'Malay', 'Filipino', 'Serbian', 'Slovak', 'Bulgarian', 'Croatian', 'Lithuanian',
    'Latvian', 'Slovenian', 'Estonian', 'Tamil', 'Telugu', 'Marathi', 'Gujarati', 'Urdu',
    'Swahili', 'Tagalog', 'Hausa', 'Burmese', 'Khmer', 'Lao', 'Sinhala', 'Pashto', 'Mongolian'
  ]);

  const languageOptions = languages.map((language) => ({
    value: language,
    label: language,
  }));

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h1 className="form-title">Setup Question</h1>
        </div>
        {error && <p className="error-message">{error}</p>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="language">Language</label>
            <Select
              id="language"
              value={languageOptions.find(option => option.value === selectedLanguage)}
              onChange={(selectedOption) => setSelectedLanguage(selectedOption?.value || '')}
              options={languageOptions}
              isSearchable
              placeholder="Select a Language"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="greetings">Greetings</label>
            <textarea
              id="greetings"
              type="text"
              rows="7"
              cols="90"
              value={greetings}
              onChange={(e) => setGreetings(e.target.value)}
              placeholder="Enter Greetings"
              required
              style={{
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                fontSize: "15px",
                width: "100%",
                resize: "vertical",
              }}
            ></textarea>
          </div>

          <div className="form-group">
            <label>Questions</label>
            {questions.map((question, index) => (
              <div key={index} className="question-field">
                <input
                  type="text"
                  value={question.text}
                  onChange={(e) => handleQuestionChange(index, e.target.value)}
                  placeholder={`Enter Question ${index + 1}`}
                  required
                />
                {index === questions.length - 1 && (
                  <button type="button" className="add-question" onClick={addQuestion}>
                    +
                  </button>
                )}
              </div>
            ))}
          </div>
          <div className="form-group">
            <label htmlFor="lastMessage">Last Message</label>
            <textarea
              id="lastMessage"
              type="text"
              rows="7"
              cols="90"
              value={lastMessage}
              onChange={(e) => setLastMessage(e.target.value)}
              placeholder="Enter Last Message"
              required
              style={{
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                fontSize: "15px",
                width: "100%",
                resize: "vertical",
              }}
            ></textarea>
          </div>
          <div className='form-buttons'>
            <button type="button" onClick={() => navigate('/event')} className="cancel-button">
              Cancel
            </button>
            <button type="submit" disabled={isLoading} className="submit-button">
              {isLoading ? (id ? 'Updating...' : 'Creating...') : (id ? 'Update Flow' : 'Create Flow')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EventFormModal;